<template>
  <div class="background" id="indexs">
    <!--FullScreen></FullScreen-->
    <div class="full" @click="full()">全屏测试</div>
    <div class="gy" @click="gy()">陀螺仪测试</div>
    <div class="title">{{msg}}</div>

<!--    <div>-->
<!--      <button class="btn"-->
<!--              v-clipboard:copy="'复制的内容'"-->
<!--              v-clipboard:success="onSuccess"-->
<!--              v-clipboard:error="onError">复制内容</button>-->
<!--    </div>-->

    <input :placeholder="holder" type="text" class="thing" v-model="player" />
    <button class="start" @click="times()">计时</button>
    <div class="end" @click="ana()">统计</div>
    <div class="list" @click="lists()">任务</div>
    <div class="detail" @click="listDetail()">完成</div>

  </div>
</template>

<script>
  import FullScreen from './FullScreen'
  export default {
    name: 'Game',
    components: {
      FullScreen
    },
    data () {
      return {
        msg: "新年快乐",
        player: localStorage.getItem("player") || "",
        holder: "输入名字",
        sss:"/work",
      }
    },
    mounted () {
      //
      // navigator.permissions.query({
      //   name: 'clipboard-read'
      // }).then(permissionStatus => {
      //   // permissionStatus.state 的值是 'granted'、'denied'、'prompt':
      //   console.log(permissionStatus.state);
      // });
      // navigator.permissions.query({
      //   name: 'clipboard-write'
      // }).then(permissionStatus => {
      //   // permissionStatus.state 的值是 'granted'、'denied'、'prompt':
      //   console.log(permissionStatus.state);
      // });
      //
      // navigator.permissions.request({ name: 'geolocation' }).then(status => {
      //   console.log(`当前状态 ${status.state}`)
      //   // status 是一个 PermissionStatus 的实例
      // });
      // navigator.permissions.request({ name: 'geolocation' }).then(status => {
      //   console.log(`当前状态 ${status.state}`)
      //   status.onchange = function() {
      //     console.log(`状态改变 ${this.state}`, this.state)
      //   }
      // });
      //
      // navigator.permissions.query({name: "clipboard-read"}).then(result => {
      //   // If permission to read the clipboard is granted or if the user will
      //   // be prompted to allow it, we proceed.
      //
      //   if (result.state == "granted" || result.state == "prompt") {
      //     navigator.clipboard.read().then(data => {
      //       for (let i=0; i<data.items.length; i++) {
      //         if (data.items[i].type != "text/plain") {
      //           alert("Clipboard contains non-text data. Unable to access it.");
      //         } else {
      //           textElem.innerText = data.items[i].getAs("text/plain");
      //         }
      //       }
      //     });
      //   }
      // });
      //
      // setTimeout(async () => {
      //   // 读取剪切板内容
      //   navigator.clipboard.writeText("AAAAA"); //.readText();
      //   alert(await navigator.clipboard.readText());
      // }, 5000);


      // this.getWorld();
    },
    methods: {
      // getWorld (){
      //   const url = "https://api.ixiaowai.cn/ylapi/index.php";
      //     //"https://www.inqingdao.cn/hitokoto/";
      //   //http://api.eei8.cn/say/api.php
      //   let that = this;
      //   this.$axios.get(url, {
      //   },{headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded'
      //   }}).then(function (response) {
      //     that.world = response.data || "";
      //   })
      // },
      onSuccess: function (res) {
        console.log('复制成功')
      },
      onError: function (err) {
        console.log('复制失败')
      },
      full () {
        window.location.href="/full";
      },
      gy () {
        window.location.href="/gy";
      },
      ana () {
        if(this.player.length===0){
          alert("请输入名字");
        }else{
          localStorage.setItem("player", this.player);
          window.location.href="/dur";
        }
      },
      times () {
        if(this.player.length===0){
          alert("请输入名字");
        }else{
          localStorage.setItem("player", this.player);
          window.location.href="/time";
        }
      },
      lists () {
        if(this.player.length===0){
          alert("请输入名字");
        }else{
          localStorage.setItem("player", this.player);
          window.location.href="/work";
        }
      },
      listDetail () {
        if(this.player.length===0){
          alert("请输入名字");
        }else{
          localStorage.setItem("player", this.player);
          window.location.href="/detail";
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  .background{
    /**https://yun.fuh.ink:8087/pic.php **/
    /**https://picsum.photos/**/
    /**https://tu.ltyuanfang.cn/api/fengjing.php**/
    /*https://tuapi.eees.cc/api.php?category={fengjing}
    https://source.unsplash.com/user/erondu/1600x900
*/
    background-image: url("https://tu.ltyuanfang.cn/api/fengjing.php");
    height: 100%;
    width: 100%;
    position: absolute;
    background-size:cover;
    background-position: center;
  }

  /*{ "position": "absolute", "width":"100%", "height":"100%", "background-size": "100% 100%", "background-repeat": "no-repeat", "background-image": "url('http://4et.oss-cn-beijing.aliyuncs.com/4et/item/61/bg.png')" }
*/

  .full{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 12%;
    left: 50%;
    color: rgb(61, 50, 39);
    font-size: 0.6rem;
    font-weight: bold;
    text-align: center;
  }
  .gy{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 12%;
    left: 70%;
    color: rgb(61, 50, 39);
    font-size: 0.6rem;
    font-weight: bold;
    text-align: center;
  }

  .title{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 80%;
    top: 16%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }
  .thing {
    position: absolute;
    width: 40%;
    height: 50px;
    top: 75%;
    left: 20%;
    color: rgb(61, 50, 39);
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }
  .start {
    opacity:0.8;
    border-radius:10px;
    background: #FFF;
    position: absolute;
    width: 20%;
    height: 50px;
    top: 75%;
    left: 60%;
    color: rgb(61, 50, 39);
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }
  .end {
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 86%;
    left: 20%;
    color: rgb(61, 50, 39);
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }
  .list {
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 86%;
    left: 40%;
    color: rgb(61, 50, 39);
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }
  .detail {
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 20%;
    top: 86%;
    left: 60%;
    color: rgb(61, 50, 39);
    font-size: 1.3rem;
    font-weight: bold;
    text-align: center;
  }

  .ful{
    opacity:0.8;
    border-radius:10px 0;
    background: #FFF;
    position: absolute;
    width: 80%;
    top: 16%;
    left: 10%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }

  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/game/Game.vue